import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of, map, catchError } from 'rxjs';
import { UserAuthService } from '../../user/services/user-auth.service';
import { PermissionService } from '../../../core/services/permission.service';

@Injectable({
  providedIn: 'root'
})
export class SystemAdminAuthGuard implements CanActivate {
  private authService = inject(UserAuthService);
  private permissionService = inject(PermissionService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authService.isAuthenticated().pipe(
      map((isAuthenticated) => {
        if (!isAuthenticated) {
          return this.router.createUrlTree(['/login'], {
            queryParams: { returnUrl: state.url }
          });
        }

        if (!this.permissionService.hasPermission('SYSTEM_ADMIN')) {
          return this.router.createUrlTree(['/access-denied']);
        }

        return true;
      }),
      catchError(() => {
        return of(this.router.createUrlTree(['/login'], {
          queryParams: { returnUrl: state.url }
        }));
      })
    );
  }
}
